import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/components/route_protection/protectedRoute.jsx';
import Login from './components/login/login.jsx';
import Calculator from './tables/calculator/calculator.jsx';
import Radii from './tables/radii/radii.jsx';
import NotFound from './tables/notFound.jsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute Component={Calculator} LoginComponent={Login} />}
        />
        <Route
          path="/radii"
          element={<ProtectedRoute Component={Radii} LoginComponent={Login} />}
        />
        <Route
          path="*"
          element={<ProtectedRoute Component={NotFound} LoginComponent={Login} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
